import React from "react"
import Section from "./section"
import CMediaTextSlider from "../elements/c_media_text_slider"

const MMediaTextSlider = (props) => {
  return (
    <Section
      baseClass="m-MediaTextSlider"
      defaultPadding="large"
      data={props.data}
    >
      <div className="m-MediaTextSlider-wrapper">
        <div className="m-MediaTextSlider-container">
          <div className="m-MediaTextSlider-content">
            <CMediaTextSlider {...props} />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MMediaTextSlider
